import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApplicationService } from '@app/shared/application/application.service';
import { MutService } from './mut.service';

@Injectable()
export class MutGuard implements CanActivate {

    constructor(
        private mutService: MutService,
        private applicationService: ApplicationService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
       return this.mutService.getMut(this.applicationService.caseId).pipe(map(() => true));
    }
}
